import React from 'react';
import './index.css';
import Offer from '../Offer';
import { Link } from "react-router-dom";
import { Button } from '@material-ui/core';
import { ResponseJSON } from '../../@types/responseJson/ResponseJSON';

type MyProps = {
    pendingOffers: boolean,
    offersJson: ResponseJSON,
    toggleApplicationPage: Function,
    step1JSON: ResponseJSON,
    step2JSON: ResponseJSON,
    pendingStepThrough: Function,
    step1?: boolean | undefined,
    step2?: boolean | undefined,
    step3?: boolean | undefined
};

type MyState = {
    step1: boolean | undefined,
    step2: boolean | undefined,
    step3: boolean | undefined,
    step1JSON: ResponseJSON,
    step2JSON: ResponseJSON
};

class Offerwall extends React.Component<MyProps, MyState>{
    constructor(props: MyProps){
        super(props); 
        this.state = {
            step1: this.props.step1,
            step2: this.props.step2,
            step3: this.props.step3,
            step1JSON: this.props.step1JSON,
            step2JSON: this.props.step2JSON
        }

        this.onSubmitOfferWall = this.onSubmitOfferWall.bind(this);
    }

    private onSubmitOfferWall(step: string, event: any) {
        if(step === "step1"){
            this.props.pendingStepThrough(1);
            this.setState((prevState) => ({
                [step]: true,
                step2: false,
                step3: false
            }));
        }
        else if(step === "step2"){
            this.props.pendingStepThrough(2);
            this.setState((prevState) => ({
                step1: false,
                [step]: true,
                step3: false
            }));
        }
        else{
            this.props.pendingStepThrough(0);
            this.setState((prevState) => ({
                ...prevState,
                step1: false,
                step2: false,
                [step]: false
            }));
        }
    }

    public render(){
        var loanAmount = this.props.offersJson.loanAmount;
        var showPendingOffersText = this.props.pendingOffers;
        var offerWall = null;

        if(showPendingOffersText) {
            if(this.state.step1){
                offerWall = (
                    <div>
                        <h1>One Offer Returned</h1>
                        <p>
                            One offer has been returned. We are also still waiting on two pending offers. These two
                            pending offers are viewable on the right under: "pendingOffers:"
                        </p>
                        {this.state.step1JSON.loanOffers.map((offer: any) =>
                            <Offer
                            key={offer.originator.key}
                            loanAmount={loanAmount}
                            offerJson={offer}
                            />
                        )}
                        <Button id="continueButton" variant="contained" color="primary" onClick={(e) => this.onSubmitOfferWall("step2", e)}>Continue</Button>    
                    </div>
                );
            }
            else if(this.state.step2){
                offerWall = (
                    <div>
                        <h1>Another Offer Returned</h1>
                        <p>
                            Another offer has been returned.  There is one last offer that is pending. The last pending
                            offer is viewable on the right under: "pendingOffers:"
                        </p>
                        {this.state.step2JSON.loanOffers.map((offer: any) =>
                            <Offer
                            key={offer.originator.key}
                            loanAmount={loanAmount}
                            offerJson={offer}
                            />
                        )}
                        <Link to="/offerwall">
                            <Button id="continueButton" variant="contained" color="primary" onClick={(e) => this.onSubmitOfferWall("step3", e)}>Continue</Button>    
                        </Link>
                    </div>
                );
            }
            else{
                offerWall = (
                    <div>
                        <h1>Pending Offers</h1>
                        <p>Posting to the Even API, waiting for offers to be returned.</p>
                        <Button id="continueButton" variant="contained" color="primary" onClick={(e) => this.onSubmitOfferWall("step1", e)}>Continue</Button>    
                    </div>
                );
            }
        }
        else{
            offerWall = (
            <div>
                <h1>Offer Wall</h1>
                <p>
                    All offers have been returned and there are no pending offers. The "pendingOffers" object should be
                    empty on the right.
                </p>
                <p>Click here if you would like to return to the application.</p>
                <Button id="continueButton" href="/application" variant="contained" color="primary" onClick={() => this.props.toggleApplicationPage()}>Return</Button>    
                {this.props.offersJson.loanOffers.map((offer: any) =>
                    <Offer 
                    key={offer.originator.key}
                    loanAmount={loanAmount}
                    offerJson={offer}/>
                )}
            </div>
            );
        }

        return(
            <div className="offerWall">
                {offerWall}
            </div>
        );
    }
}

export default Offerwall;